/**
 * Resolves the PDF/image blob URL for ShowSlides based on route (print vs shared vs logged-in deck).
 * PDF.js loads this via same-origin fetch with credentials; paths must stay relative (no CORS).
 */
export function blobSlideSrc(
    routeName: string | null | undefined,
    documentId: string | undefined,
    blobId: string,
): string {
    const name = routeName || '';
    if (name.endsWith('print')) {
        return `/admin/blob/${blobId}`;
    }
    if (name.startsWith('presentation-shared')) {
        return `/api/shared/${documentId}/blob/${blobId}`;
    }
    return `/api/user/blob/${blobId}`;
}
